<template>
  <DatatableReportV3
    title="Balance Due Customers"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import CONSTANTS from "@/Constants.js";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        order: [[2, "desc"]],
        columns: [
          { data: "customer" },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          {
            data: "address",
            title: "Billing Address",
            orderable: false
          },
          {
            data: "last_invoice_date",
            title: "Last Invoice",
            searchable: false
          },
          {
            data: "invoices",
            className: "text-center",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.invoices,
            footerClassName: "text-right",
            searchable: false
          },
          {
            data: "balance",
            title: "Balance Due",
            className: "text-right",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.balance,
            footerClassName: "text-right",
            searchable: false
          }
        ],
        vueComponents: []
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Balance Due Customers" });
  }
};
</script>

<style lang="scss" scoped></style>
